import { useTranslation } from "react-i18next";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import {
	getFieldDefinition,
	getOperatorsForFieldType,
	Operator
} from "@/types/queryBuilder";

interface OperatorSelectorProps {
	fieldKey: string;
	value: Operator;
	onChange: (operator: Operator) => void;
}

export function OperatorSelector({ fieldKey, value, onChange }: OperatorSelectorProps) {
	const { t } = useTranslation();
	const field = getFieldDefinition(fieldKey);
	const operators = getOperatorsForFieldType(field?.type || 'text');

	return (
		<Select value={value} onValueChange={(v) => onChange(v as Operator)}>
			<SelectTrigger className="w-[180px]">
				<SelectValue placeholder={t("queries.selectOperator", "Select operator")} />
			</SelectTrigger>
			<SelectContent>
				{operators.map((op) => (
					<SelectItem key={op.key} value={op.key}>
						{t(`queries.operators.${op.key}`, op.label)}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
